import React, { useState } from "react";
import axios from "axios";

import LeftSection from "../../Components/Auth/LeftSection";
import classes from "../../Components/Auth/RightSection.module.css";

import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import logo from "../../Assets/MMT_Green_Black.png";

import "../../App.css";

const schema = yup
  .object()
  .shape({
    gst_number: yup
      .string()
      .required("GST number is required!")
      .matches(
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
        "Please enter a valid GST number!"
      )
      .length(15, "GST number must be exactly 15 characters long!"),
    mobile: yup
      .string()
      .required("Contact number is required!")
      .length(10, "Contact number must be exactly 10 digits long!"),
    linkCheckbox: yup
      .boolean()
      .required("You must agree to the terms and conditions!")
      .oneOf([true], "You must agree to the terms and conditions!"),
  })
  .required();

export default function Registration() {
  const navigate = useNavigate();
  const [buttonClick, setButtonClick] = useState(false);

  const { register, handleSubmit, formState, setError } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const { errors } = formState;

  const onSubmit = (data) => {
    setButtonClick(true);
    let gstData = { gstin: data.gst_number };

    axios
      .post(`${process.env.REACT_APP_GST_CHECK_URL}`, gstData, {
        headers: { "x-api-key": process.env.REACT_APP_X_API_KEY },
      })
      .then((res) => {
        if (res.data.statusCode === 400) {
          setError("gst_number", {
            type: "manual",
            message: "Invalid GST number. Please provide a valid GST number.",
          });
        } else {
          axios
            .post(`${process.env.REACT_APP_OTP_URL}otp/generate-otp`, data)
            .then((res1) => {
              setButtonClick(false);
              if (res1.data.statusCode === 400) {
                setError("mobile", {
                  type: "manual",
                  message:
                    "We are unable to send the OTP at the moment. Please try again later.",
                });
              } else {
                const saveData = {
                  mobile: data.mobile,
                  gst_number: data.gst_number,
                  gst_details: res.data.data.data,
                };
                localStorage.setItem("mmt_login_mobile", data.mobile);
                localStorage.setItem(
                  "mmt_registration_data",
                  JSON.stringify(saveData)
                );
                navigate("/verify-otp");
              }
            })
            .catch(() => {
              setError("mobile", {
                type: "manual",
                message:
                  "We are unable to send the OTP at the moment. Please try again later.",
              });
              setButtonClick(false);
            });
        }
      })
      .catch(() => {
        setError("gst_number", {
          type: "manual",
          message:
            "We are unable to fetch GST details at the moment. Please try again later.",
        });
        setButtonClick(false);
      });
  };

  return (
    <main>
      <div className="flex flex-col md:flex-row items-center justify-center min-h-screen ">
        <div
          // className="w-full md:w-1/2"
          className="hidden md:block w-1/2"
        >
          <LeftSection />
        </div>

        <div className="w-full  md:w-1/2 relative bg-gray-50 flex items-center justify-center p-6 ">
          <div className="w-full max-w-sm flex flex-col items-center justify-center min-h-screen md:min-h-[auto]">
            <div className="w-full max-w-sm mb-8 md:hidden  flex justify-center">
              <img src={logo} alt="Logo" className={classes.logoImage} />
            </div>
            {/* <div className={`p-5 sm:px-8 md:px-20 py-16 ${classes.RhtFormSec}`}> */}
            <h2 className="text-2xl md:text-3xl mb-3 font-semibold">
              Register Account!
            </h2>
            <p
              className="text-sm md:text-base mb-8"
              style={{ color: "#8692A6" }}
            >
              For the purpose of industry regulation, your details are required.
            </p>

            <div className="mb-5 w-full">
              <label className="w-full mb-2 text-sm md:text-base">
                GST Number
              </label>
              <input
                type="text"
                className={`rounded-md w-full ${classes.inputBox}`}
                placeholder="Please enter GST number"
                {...register("gst_number")}
              />
              <span className="text-danger text-xs md:text-sm">
                {errors.gst_number?.message}
              </span>
            </div>

            <div className="mb-5 w-full">
              <label className="w-full mb-2 text-sm md:text-base">
                Contact Number
              </label>
              <input
                type="text"
                className={`rounded-md w-full ${classes.inputBox}`}
                placeholder="Please enter contact number"
                {...register("mobile")}
              />
              <span className="text-danger text-xs md:text-sm">
                {errors.mobile?.message}
              </span>
            </div>

            <div className="flex items-center gap-2 mt-0">
              <input
                id="link-checkbox"
                type="checkbox"
                className=""
                {...register("linkCheckbox")}
              />
              <label className="!mb-0 text-sm md:text-base">
                I agree to{" "}
                <a
                  href="#"
                  className="underline ms-2 capitalize"
                  style={{ color: "#005EFF" }}
                >
                  Terms & conditions
                </a>
              </label>
            </div>
            <div className="text-danger text-xs md:text-sm">
              {errors.linkCheckbox?.message}
            </div>

            <button
              type="submit"
              className={`w-full ${
                buttonClick ? "secondary-color" : "main-color"
              } p-3 sm:p-4 rounded-lg text-sm sm:text-base text-white mt-5 flex items-center justify-center`}
              disabled={buttonClick}
              onClick={handleSubmit(onSubmit)}
            >
              {buttonClick ? "Loading..." : "Register Account"}
            </button>

            <p
              className="mt-2 text-center text-sm md:text-base"
              style={{ color: "#8692A6" }}
            >
              Already have an account?{" "}
              <span
                onClick={() => navigate("/login")}
                className="underline ms-2 capitalize cursor-pointer"
                style={{ color: "#005EFF" }}
              >
                Login here
              </span>
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}
